import axios from "axios";

// Public API Client - for user-related endpoints (waitlist, book demo, etc.)
const apiClient = axios.create({
  baseURL:
    process.env.NEXT_PUBLIC_API_BASE_URL ||
    "https://us-central1-zylen-server.cloudfunctions.net/app/api",
  timeout: 10000,
  headers: {
    "Content-Type": "application/json",
  },
});

// TopGeo API Client - for report generation and lead analysis
export const topgeoApiClient = axios.create({
  baseURL:
    process.env.NEXT_PUBLIC_TOPGEO_API_BASE_URL || "https://api2.topgeo.ai/api",
  timeout: 30000, // Longer timeout for report generation
  headers: {
    "Content-Type": "application/json",
  },
});

// Response interceptor for public API
apiClient.interceptors.response.use(
  (response) => response,
  (error: any) => {
    const message =
      error.response?.data?.message ||
      error.message ||
      "Network error occurred";
    return Promise.reject(new Error(message));
  },
);

// Response interceptor for TopGeo API
topgeoApiClient.interceptors.response.use(
  (response) => response,
  (error: any) => {
    const message =
      error.response?.data?.message ||
      error.message ||
      "Network error occurred";
    return Promise.reject(new Error(message));
  },
);

export interface BookDemoRequest {
  name: string;
  email: string;
  phone: string;
  company: string;
  preferredDate: string;
}

export interface EnterpriseFormRequest {
  brandName: string;
  email: string;
  phone: string;
  implementationTimeline: string;
  referralSource: string;
}

export async function joinWaitlist(email: string): Promise<void> {
  await apiClient.post("/user/join-waitlist", { email });
}

export async function bookDemo(data: BookDemoRequest): Promise<void> {
  await apiClient.post("/user/book-demo", data);
}

export async function submitEnterpriseForm(
  data: EnterpriseFormRequest,
): Promise<void> {
  await apiClient.post("/user/enterprise-form", data);
}
